<template>
  <div class="contain padc">
    <div class="layout-desc-check">
      <div class="name-check-desc">{{this.custName}}</div>
      <div class="content-desc-check">
        <div class="ele-desc-check"><span class="label-desc-check">销售员</span><span class="info-desc-check">{{this.applyName}}</span></div>
        <div class="ele-desc-check"><span class="label-desc-check">客户</span><span class="info-desc-check">{{this.cust}}</span></div>
        <div class="ele-desc-check"><span class="label-desc-check">访问日期</span><span class="info-desc-check">{{this.time}}</span></div>
        <!-- <div class="ele-desc-check"><span class="label-desc-check">下次访问日期</span><span class="info-desc-check">{{this.nextVisitTime}}</span></div> -->
        <div class="ele-desc-check"><span class="label-desc-check">访问方式</span><span class="info-desc-check">{{this.vitstTypeTxt}}</span></div>
        <div class="layout-desc-check">
          <div class="tit-desc-check color-nol">主访人</div>
          <div class="content-desc-check cotent-contact-check"
               v-for="p in persons.mainVisiter"
               :key="p.tempId">
            <div>
              <div class="ele-desc-check"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.name}}</span></div>
              <div class="ele-desc-check"><span class="label-desc-check">下次访问日期</span><span class="info-desc-check">{{p.nextDate}}</span></div>
            </div>
          </div>
        </div>
        <div class="layout-desc-check">
          <div class="tit-desc-check color-nol">随访人</div>
          <div class="content-desc-check cotent-contact-check"
               v-for="p in persons.withVisiter"
               :key="p.tempId">
            <div>
              <div class="ele-desc-check"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.name}}</span></div>
              <div class="ele-desc-check"><span class="label-desc-check">下次访问日期</span><span class="info-desc-check">{{p.nextDate}}</span></div>
            </div>
          </div>
        </div>
        <!-- <div class="ele-desc-check"
             v-for="(p,index) in persons"
             :key="index"
             :class="index==persons.length-1?'noborderb':''"><span class="label-desc-check">被访者</span><span class="info-desc-check">{{p}}</span></div> -->
      </div>
    </div>
    <div class="layout-desc-check">
      <div class="tit-desc-check">访谈记录</div>
      <div class="node-desc-check">
        {{this.visistContent}}
      </div>
    </div>

    <div class="layout-desc-check"
         v-if="showLocation">
      <div class="tit-desc-check">打卡信息</div>
      <div v-if="!showNotice">
        <div class="content-desc-check cotent-contact-check"
             v-for="p in checkinData"
             :key="p.id">
          <div>
            <div class="ele-desc-check"><span class="label-desc-check">打卡时间</span><span class="info-desc-check">{{p.checkTimeStr}}</span></div>
            <div class="ele-desc-check"><span class="label-desc-check">打卡地点</span><span class="info-desc-check">{{p.address}}</span></div>
            <div class="ele-desc-check"><span class="label-desc-check">距离客户（米）</span><span class="info-desc-check">{{p.distance}}</span></div>
            <div class="ele-desc-check"><span class="label-desc-check">经度</span><span class="info-desc-check">{{p.lng}}</span></div>
            <div class="ele-desc-check"><span class="label-desc-check">纬度</span><span class="info-desc-check">{{p.lat}}</span></div>
          </div>
        </div>
      </div>
      <div v-if="showNotice">
        <div class="node-desc-check"
             style="color:#FF5151">
          {{this.noticeTxt+",无法查看打卡信息"}}
        </div>
      </div>
    </div>

    <div class="layout-desc-check"
         v-if="approveShow">
      <div class="tit-desc-check color-nol">审批意见</div>
      <textarea class="textarea-addvisit"
                placeholder="请输入审批意见"
                v-model="approveContent"
                @click="showheigh()"></textarea>
    </div>
    <ApproveBottom :id="id"
                   :approveType="approveType"
                   :approveContent="approveContent"></ApproveBottom>
  </div>
</template>

<script>
import ApproveBottom from '../../components/approve/ApproveBottom.vue'
import reportModel from '../../api/model/visit-report'
import checkinModel from '../../api/model/checkin'
import { mapState } from 'vuex'
import { nanoid } from 'nanoid'
export default {
  name: 'VisitReport',
  data() {
    return {
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      cust: '',
      applyName: '',
      time: '',
      vitstType: '',
      vitstTypeTxt: '',
      visitPersons: '',
      visistContent: '',
      approveContent: '',
      nextVisitTime: '',

      checkinData: [],

      showNotice: false,
      noticeTxt: '',

      submitShow: true, //是否显示提交按钮

      approveShow: true, //显示审批意见

      showLocation: false, //显示定位

      mainVisitPersons: '',
      withVisitPersons: '',
      mainNextDate: '',
      withNextDate: '',
    }
  },
  components: {
    ApproveBottom,
  },
  methods: {
    showheigh() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
    async getReportInfo() {
      let res
      if (this.approveType == this.approveParam.visitReport) {
        res = await reportModel.getApproveReportDetail({
          id: this.id,
        })
      } else if (this.approveType == this.approveParam.invalidReport) {
        this.approveShow = false
        res = await reportModel.getInvalidReportDetail({
          id: this.id,
        })
      }

      if (res.success) {
        this.cust = res.data.cust
        this.applyName = res.data.applyName
        this.time = res.data.time
        this.vitstType = res.data.vitstType
        this.vitstTypeTxt = res.data.vitstTypeTxt
        //this.visitPersons = res.data.visitPersons
        this.visistContent = res.data.visistContent
        this.approveContent = res.data.approveContent
        //this.nextVisitTime = res.data.nextVisitTime
        this.mainVisitPersons = res.data.mainVisitPersons
        this.withVisitPersons = res.data.withVisitPersons
        this.mainNextDate = res.data.mainNextDate
        this.withNextDate = res.data.withNextDate
        this.visiters = {}
        if (this.vitstType == '01') {
          this.showLocation = true
        }
      } else {
        this.$toast(res.msg)
      }
    },
    async getCheck() {
      let res
      res = await checkinModel.getSignCheckRecordsByUserAndDate({
        reportId: this.id,
      })

      if (res.success) {
        if (res.code != -14) {
          this.showNotice = false
          res.data.forEach((element) => {
            this.checkinData.push(element)
          })
        } else {
          this.showNotice = true
          this.noticeTxt = res.msg
        }
      } else {
        this.$toast(res.msg)
      }
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
  },
  computed: {
    custName() {
      const index = this.cust.indexOf(')')
      return this.cust.substr(index + 1, this.cust.length - index)
    },
    persons() {
      console.log(this.mainVisitPersons, this.mainNextDate)
      var mianPerson = this.mainVisitPersons.split('#')
      var mainNext = []
      if (this.mainNextDate != null) {
        mainNext = this.mainNextDate.split('#')
      }
      var mainVisiter = []
      mianPerson.forEach((item, index) => {
        var next = ''
        if (index < mainNext.length) {
          next = mainNext[index]
        }
        if (item != '') {
          mainVisiter.push({
            tempid: nanoid(),
            name: item,
            nextDate: next,
          })
        }
      })
      var withVisiter = []
      if (this.withVisitPersons != null) {
        var withPerson = this.withVisitPersons.split('#')
        var withNext = []
        if (this.withNextDate != null) {
          withNext = this.withNextDate.split('#')
        }
        withPerson.forEach((item, index) => {
          var next = ''
          if (index < withNext.length) {
            next = withNext[index]
          }
          if (item != '') {
            withVisiter.push({
              tempid: nanoid(),
              name: item,
              nextDate: next,
            })
          }
        })
      }

      var visiter = {
        mainVisiter: mainVisiter,
        withVisiter: withVisiter,
      }
      return visiter
    },
    ...mapState('systemAbout', ['approveParam']),
  },
  props: ['id', 'approveType'],
  mounted() {
    this.getReportInfo()
    this.getCheck()
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }
  },
}
</script>

<style scoped>
</style>